import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Text from "@material-ui/core/FormHelperText";
import { useTranslation } from 'react-i18next';

export default function AlertDialog(props) {
  const { message } = props;
  const [open, setOpen] = React.useState(true);
  const { t, i18n } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"><div>
          <Text style={{
            fontSize: '1.25rem',
            color : '#0868B3',
            fontFamily: 'Myriad Pro',
          }}>{message}</Text></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            <Text style={{
              fontSize: '1rem',
              color : 'black',
              fontFamily: 'Myriad Pro',
            }}>{t('ok')}</Text>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}